// The /faq questions. FAQs.js renders them and seoConfig builds the FAQ structured data from the
// same list, so what search engines read always matches what visitors see.
import { PILOT_OFFER as OFFER } from "./pilotOffer";

export const FAQ_SECTIONS = [
  {
    id: "getting-started",
    category: "Getting started",
    icon: "spark",
    questions: [
      { question: "What is ZediPass?", answer: "ZediPass is loyalty and customer engagement software for independent businesses. It helps you launch digital rewards, share offers and see who comes back, all in one place." },
      { question: "How fast can I launch ZediPass?", answer: "Most businesses are set up the same day: set your rewards, print your QR and start scanning customers." },
      { question: "Do customers need to download an app to join?", answer: "Customers show their pass in the free ZediPass app. Your team scans it with the ZediPass Business app." },
      { question: "Who gets the most value from ZediPass?", answer: "Independent cafés, salons, barbers, market traders and local service brands that want more repeat visits without enterprise complexity." },
    ],
  },
  {
    id: "product",
    category: "Product and integrations",
    icon: "store",
    questions: [
      { question: "Can ZediPass work without replacing my POS?", answer: "Yes. ZediPass works alongside your current till with QR sign-up and simple team workflows. No POS required." },
      { question: "What types of loyalty programs can I run?", answer: "Digital stamp cards with milestone rewards on every plan, a daily perk for regulars on Growth, and several perks a day and flash offers on Scale." },
      { question: "Can I update rewards and campaigns later?", answer: "Yes. You can change rewards, offers and settings at any time. Changes to a live offer start the following Monday, so customers are never caught out." },
    ],
  },
  {
    id: "billing",
    category: "Plans and billing",
    icon: "tag",
    questions: [
      { question: "How do I get started?", answer: "Book a short demo and we'll walk you through the platform. If it's a fit, you can be set up the same day on a monthly plan, with no contract and the option to cancel any time." },
      { question: `Is there a pilot for new businesses?`, answer: `Yes. Places on the Founding Merchant pilot are limited. Eligible businesses can join with ${OFFER.freeMonths} months free. The pilot page has the full terms.` },
      { question: "How does pricing work as I grow?", answer: "ZediPass uses simple monthly plans. Start on a smaller plan and upgrade as your customer base grows." },
      { question: "Can I change or cancel my plan anytime?", answer: "Yes. Upgrade or downgrade from billing settings. If you cancel, access stays active until the end of the current billing period." },
    ],
  },
  {
    id: "results",
    category: "Results and security",
    icon: "chart",
    questions: [
      { question: "What should I track in the first 90 days?", answer: "Sign-ups, repeat visits, reward redemptions and total visits. Your ZediPass dashboard shows these so you can adjust quickly." },
      { question: "What onboarding and support do you provide?", answer: `We help you set up and we're on hand while you get going. Contact us any time at ${OFFER.supportEmail} or on WhatsApp ${OFFER.whatsappNumber}.` },
      { question: "How does ZediPass protect customer data?", answer: "ZediPass uses encryption in transit and at rest, secure authentication practices and GDPR-aligned data controls to protect merchant and customer information." },
    ],
  },
];

export const FAQ_ENTRIES = FAQ_SECTIONS.flatMap((section) => section.questions);
